var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.49996 4.66602H5.83329C5.39127 4.66602 4.96734 4.84161 4.65478 5.15417C4.34222 5.46673 4.16663 5.89065 4.16663 6.33268V16.3327C4.16663 16.7747 4.34222 17.1986 4.65478 17.5112C4.96734 17.8238 5.39127 17.9993 5.83329 17.9993H14.1666C14.6087 17.9993 15.0326 17.8238 15.3451 17.5112C15.6577 17.1986 15.8333 16.7747 15.8333 16.3327V6.33268C15.8333 5.89065 15.6577 5.46673 15.3451 5.15417C15.0326 4.84161 14.6087 4.66602 14.1666 4.66602H12.5",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49996 4.66602H5.83329C5.39127 4.66602 4.96734 4.84161 4.65478 5.15417C4.34222 5.46673 4.16663 5.89065 4.16663 6.33268V16.3327C4.16663 16.7747 4.34222 17.1986 4.65478 17.5112C4.96734 17.8238 5.39127 17.9993 5.83329 17.9993H14.1666C14.6087 17.9993 15.0326 17.8238 15.3451 17.5112C15.6577 17.1986 15.8333 16.7747 15.8333 16.3327V6.33268C15.8333 5.89065 15.6577 5.46673 15.3451 5.15417C15.0326 4.84161 14.6087 4.66602 14.1666 4.66602H12.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 3H9.16667C8.24619 3 7.5 3.74619 7.5 4.66667C7.5 5.58714 8.24619 6.33333 9.16667 6.33333H10.8333C11.7538 6.33333 12.5 5.58714 12.5 4.66667C12.5 3.74619 11.7538 3 10.8333 3Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12.166H7.50833",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.666H7.50833",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 13.8327L10.8333 14.666L13.3333 12.166",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStock);
export default __webpack_public_path__ + "static/media/stock.86141731e45fc682dc047533e112f23d.svg";
export { ForwardRef as ReactComponent };